import { render, staticRenderFns } from "./r-status.vue?vue&type=template&id=51406a42"
import script from "./r-status.vue?vue&type=script&lang=js"
export * from "./r-status.vue?vue&type=script&lang=js"
import style0 from "./r-status.vue?vue&type=style&index=0&id=51406a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports